import React from "react";
import "./SystemStatusStatus.scss";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { CaptionBody, Colors } from "src/components";
import { SpintrTypes } from "src/typings";

interface IProps {
    icon?: string;
    text: string;
    type: SpintrTypes.SystemStatusType;
    displayIcon?: boolean;
    displayStatusCircle?: boolean;
    iconColor?: spintrColors;
    textColor: Colors;
}

const SystemStatusStatus = (props: IProps) => {
    return (
        <div className={[
            "SystemStatusStatus",
            "type-" + props.type
        ].join(" ")}>
            <div className="SystemStatusStatus-inner">
                {props.displayIcon && <Visage2Icon size="small" icon={props.icon} color={props.iconColor} />}
                {props.displayStatusCircle && <div className="status-circle" />}
                <CaptionBody color={props.textColor}>
                    {props.text}
                </CaptionBody>
            </div>
        </div>
    )
}

export default SystemStatusStatus;